const my_profile = {
  viewMyClubSeacretProfile: "Visualizza il profilo di My ClubSecret", // translated
  unverifiedEmail: "E-mail non verificata", // translated
  verifiedEmail: "E-mail verificata", // translated
  viewMoreDetails: "Visualizza ulteriori dettagli", // translated
  createdFrom: "Creato da", // translated
  createdTo: "Creato fino a", // translated
  selectStatus: "Seleziona stato...", // translated
  searchByTitle: "Cerca per titolo...", // translated
  pushNotifications: "Notifiche Push",
  pushNotificationsDescription: "Ricevi notifiche del browser per aggiornamenti ed eventi importanti",
  pushNotificationsNotSupported: "Le notifiche push non sono supportate in questo browser",
  pushNotificationsDeniedMessage: "Il permesso di notifica è stato negato. Si prega di abilitare le notifiche nelle impostazioni del browser per ricevere notifiche push.",
  pushNotificationsEnabled: "Notifiche push abilitate con successo",
  pushNotificationsDisabled: "Notifiche push disabilitate con successo",
  userInformationMissing: "Le informazioni utente sono mancanti",
  failedToUpdatePushNotifications: "Impossibile aggiornare le impostazioni delle notifiche push",
  notificationPermissionDenied: "Il permesso di notifica è stato negato. Si prega di abilitarlo nelle impostazioni del browser.",
  notificationPermissionRequired: "Il permesso di notifica è richiesto per abilitare le notifiche push",
  notSupported: "Non supportato",
  permissionDenied: "Permesso negato",
  permissionNotRequested: "Permesso non richiesto",
  enabled: "Abilitato",
  disabled: "Disabilitato",
};

export default my_profile;
